import { Typography, ProgressiveReading, Input } from '@evocolabs/orkaui'
import Box from '@mui/material/Box'
import Link from 'next/link'
import Search24 from '@evocolabs/icons/lib/Search24'
import PhoneConnect64 from '@evocolabs/icons/lib/PhoneConnect64'
import CaseOrkaOneHand64 from '@evocolabs/icons/lib/CaseOrkaOneHand64'
import AudiologistRemote64 from '@evocolabs/icons/lib/AudiologistRemote64'
import Headphone64 from '@evocolabs/icons/lib/Headphone64'
import ShieldBox64 from '@evocolabs/icons/lib/ShieldBox64'
import Order64 from '@evocolabs/icons/lib/Order64'
import Shipping64 from '@evocolabs/icons/lib/Shipping64'
import { NextSeo } from 'next-seo'
import { FAQEntryWithFeedback } from './FAQUtils'
import { useState } from 'react'

import styles from '@/pages/scss/FAQ.module.scss'

function FAQHeader() {
  return (
    <div className={styles['faq-header-wrapper']}>
      <div>
        <Typography variant="h1" textAlign="center" color="#ffffff">
          FAQ
        </Typography>
        <Typography
          variant="subh1"
          textAlign="center"
          mt={1}
          mb={3}
          color="#ffffff"
        >
          Everything you need to know about Orka
        </Typography>
        <Link href={'/FAQ/Search'} className={styles.searchBoxMobile}>
          <Input
            variant="filled"
            fullWidth
            placeholder="Search for questions"
            icon={<Search24 />}
            id="input_faq-search"
          />
        </Link>
      </div>
    </div>
  )
}

const TopicItem = ({ title, icon }) => {
  return (
    <Link href={`/FAQ/section/${title}`}>
      <Box className={styles.topicItemWrapper}>
        {icon}
        <Typography variant="subh2" textAlign="center">
          {title}
        </Typography>
      </Box>
    </Link>
  )
}

const FAQBody = ({ data }) => {
  const commonQuestionsData = data.results.data
    .filter((d) => d.is_common)
    .sort((a, b) => b.frequency - a.frequency)

  const topicItemsCfg = [
    { title: 'Online Hearing Screening', icon: <Headphone64 /> },
    { title: 'Product Details', icon: <CaseOrkaOneHand64 /> },
    { title: 'App', icon: <PhoneConnect64 /> },
    { title: 'Remote Care', icon: <AudiologistRemote64 /> },
    { title: 'Payment & Order', icon: <Order64 /> },
    { title: 'Shipping & Return', icon: <Shipping64 /> },
    { title: 'Warranty & Insurance', icon: <ShieldBox64 /> }
  ]

  const [expanded, setExpanded] = useState('')

  const clickHandler = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : '')
  }

  return (
    <Box className={styles.faqBodyMobWrapper}>
      <Typography variant="h3">Common Questions</Typography>
      <Box className={styles.faqProgressiveReadingWrapper}>
        <ProgressiveReading
          content={commonQuestionsData.map((d, idx) => {
            return {
              question: d.question,
              answer: <FAQEntryWithFeedback data={d} pc={false} />,
              id: d.question.replace(/[\W_]+/g, '_'),
              expanded: expanded === idx,
              setExpansion: clickHandler(idx)
            }
          })}
        />
      </Box>
      <Typography variant="h3" mt={5}>
        Browse by Topic
      </Typography>
      <Box className={styles.topicItems}>
        {topicItemsCfg.map((config) => (
          <TopicItem {...config}></TopicItem>
        ))}
      </Box>
    </Box>
  )
}

const FAQMobile = ({ data }) => {
  return (
    <>
      <NextSeo
        title="Frequently Asked Questions | Orka Hearing Aids"
        description="Explore Orka’s FAQ page for quick answers on Orka, Orka hearing aids, hearing loss, and more."
      />
      <FAQHeader />
      <FAQBody data={data} />
    </>
  )
}

export default FAQMobile
